'use client';

import { UserIcon } from '@phosphor-icons/react';

import {
    benefitsId,
    howItWorksId,
    partnersId,
    servicesId,
} from '@/utils/sectionIds';

import type { NavigationConfigType } from '@/components/organisms/Navigation/Navigation.types';

import { env } from '@/env.mjs';

export const NAVIGATION_CONFIG: NavigationConfigType = {
    links: [
        {
            name: 'Dla klientów',
            menu: {
                lead: {
                    name: 'PayPo dla klientów',
                    href: '/',
                    dataTestId: 'main-nav-homepage-link',
                },
                list: [
                    {
                        name: 'Jak to działa?',
                        relatedSectionId: howItWorksId,
                        href: `/#${howItWorksId}`,
                        dataTestId: 'main-nav-how-it-works-link',
                    },
                    {
                        name: 'Usługi PayPo',
                        relatedSectionId: servicesId,
                        href: `/#${servicesId}`,
                        dataTestId: 'main-nav-services-ref',
                    },
                    {
                        name: 'Korzyści',
                        relatedSectionId: benefitsId,
                        href: `/#${benefitsId}`,
                        dataTestId: 'main-nav-benefits-link',
                    },
                    {
                        name: 'Promocje',
                        relatedSectionId: partnersId,
                        href: `/#${partnersId}`,
                        dataTestId: 'main-nav-partners-link',
                    },
                    {
                        name: 'Kontakt',
                        href: '/p/kontakt',
                        dataTestId: 'main-nav-contact-link',
                    },
                ],
            },
        },
        {
            name: 'Dla sklepów',
            menu: {
                lead: {
                    name: 'PayPo dla sklepów',
                    href: `/biznes`,
                    dataTestId: 'main-nav-business-page-link',
                },
                list: [
                    {
                        name: 'Korzyści',
                        href: `/biznes#section-benefits`,
                        dataTestId: 'main-nav-business-benefits-link',
                    },
                    {
                        name: 'Jak to działa?',
                        href: `/biznes#section-how-it-works`,
                        dataTestId: 'main-nav-business-how-it-works-link',
                    },
                    {
                        name: 'Dlaczego warto?',
                        href: `/biznes#section-why-worth`,
                        dataTestId: 'main-nav-business-why-worth-link',
                    },
                    {
                        name: 'Integracja',
                        href: `/biznes/integracja`,
                        dataTestId: 'main-nav-business-integration-link',
                    },
                    {
                        name: 'Kontakt',
                        href: `/biznes#section-collaboration`,
                        dataTestId: 'main-nav-business-contact-link',
                    },
                ],
            },
        },
        {
            name: 'Dostępne sklepy',
            href: '/p/dostepnesklepy/',
            dataTestId: 'main-nav-available-shops-page-link',
        },
        {
            name: 'Płać z aplikacją',
            href: '/p/plac-z-aplikacja/',
            dataTestId: 'main-nav-pay-with-app-page-link',
        },
        {
            name: 'Kontakt',
            href: '/p/kontakt/',
            dataTestId: 'main-nav-contact-page-link',
        },
    ],
    buttons: [
        {
            children: 'Zaloguj się',
            href: `${env.NEXT_PUBLIC_WWW_URL}/home/zaloguj`,
            variant: 'outline',
            size: 'm',
            dataTestId: 'main-nav-login-page-button',
            className: 'text-nowrap',
        },
        {
            children: 'Załóż konto',
            size: 'm',
            href: `${env.NEXT_PUBLIC_PANEL_URL}/registration`,
            dataTestId: 'main-nav-registration-page-button',
            className: 'text-nowrap',
        },
    ],
    mobileControls: [
        {
            href: `${env.NEXT_PUBLIC_WWW_URL}/home/zaloguj`,
            icon: <UserIcon weight="bold" />,
            ariaLabel: 'Przejdź do strony logowania',
        },
    ],
};
